<template>
  <div class="section section__company">
    <div class="section__wrapper">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentSectionWrapper'
}
</script>
